import { global } from "../../constants";

export const data = {
  banner: {
    base: "Services",
    background: global.banner + "maritime-law.webp",
    title: "Commercial Law",
    crumb: "Commercial Law",
  },
  icon: "fa-solid fa-scale-balanced",
  shortDescription:
    "Comprehensive service for the incorporation and regularization of Venezuelan companies: from the founding document to legal, tax, and administrative operations.",
  title: "Commercial Law",
  features: {
    title: "Commercial Law",
    deliverables: "Deliverables",
    reqDocuments: "Required Documents",
    subtitle:
      "Incorporation of Venezuelan companies and a package of commercial services to get your business operating in compliance with local regulations.",
    description: `Comprehensive service for company incorporation and commercial regularization: we draft the founding document, prepare powers of attorney, manage registrations and publications, organize inventories and opening balances, open bank accounts, process the RIF, and register with agencies such as INCES and IVSS. We also offer drafting and analysis of commercial contracts for the company's operational activity.`,
    viewDetail: "View Details",
    feats: [
      {
        key: "incorporation",
        title: "Drafting of the founding document and its registration",
        summary:
          "Personalized drafting of the articles of incorporation/bylaws and complete management of the commercial registry until effective registration.",
        details:
          "We design the founding document according to the recommended company type (C.A., S.R.L., etc.), share structure, capital, and management rules. Includes drafting of bylaws, social clauses, inherent powers, and submission to the competent Commercial Registry until registration is obtained.",
        deliverables: [
          "Draft of the founding document (Word/PDF)",
          "Protocolized act and notarial signature (as applicable)",
          "Proof of registry inscription"
        ],
        requiredDocs: [
          "Shareholder/partner data (ID, RIF if applicable)",
          "Decision on company type and capital amount",
          "Powers or authorizations if applicable"
        ],
        icon: "fa-solid fa-file-signature",
        image: global.services + "commercial_law/1.webp",
      },
      {
        key: "powers",
        title: "Drafting of notarial and corporate powers of attorney",
        summary:
          "Drafting and protocolization of powers for legal representatives, attorneys-in-fact, and administrative managers.",
        details:
          "We prepare limited or general powers tailored to operational needs (bank openings, tax management, registry procedures). We advise on scope, duration, and revocability; coordinate signing and notarial legalization.",
        deliverables: [
          "Draft of power of attorney (Word/PDF)",
          "Format for protocolization at notary",
          "Presentation and validity checklist"
        ],
        requiredDocs: [
          "Identification of attorney-in-fact and grantor",
          "Authorization data (scope and limit)",
          "Supporting company documents"
        ],
        icon: "fa-solid fa-pen-fancy",
        image: global.services + "commercial_law/2.webp",
      },
      {
        key: "translation",
        title: "Legal translation and legalization of documents",
        summary:
          "Certified translation of bylaws, powers of attorney, and notarial documents for use in Venezuela or foreign jurisdictions.",
        details:
          "We coordinate sworn translations and their legalization or apostille (as applicable), ensuring legal equivalence and compliance with administrative requirements. Ideal for foreign investors and documents originally in other languages.",
        deliverables: [
          "Sworn translation of documents",
          "Legalization/apostille guide",
          "Documents ready for registration/delivery"
        ],
        requiredDocs: [
          "Original documents to be translated",
          "Instructions on required language and format",
          "Applicant identification"
        ],
        icon: "fa-solid fa-language",
        image: global.services + "commercial_law/3.webp",
      },
      {
        key: "migration_status",
        title:
          "Adjustment of migration status for foreign shareholders/representatives",
        summary:
          "Advice and coordination to regularize the migration status of non-resident partners or representatives.",
        details:
          "We assist with permits, visas, and necessary documentation so that foreign shareholders or attorneys-in-fact can perform corporate functions and meet administrative requirements. We coordinate with migration offices and competent agencies as needed.",
        deliverables: [
          "List of migration requirements per case",
          "Processing or coordination with migration specialists",
          "Templates and supporting documents"
        ],
        requiredDocs: [
          "Passport and personal documentation of the foreigner",
          "Company documents proving the relationship",
          "Powers and authorizations"
        ],
        icon: "fa-solid fa-passport",
        image: global.services + "commercial_law/4.webp",
      },
      {
        key: "commissioner",
        title: "Provision or advice for appointment of commissioner",
        summary:
          "Assistance in the appointment of the commercial commissioner and in the control and audit functions that correspond to them.",
        details:
          "We advise on the figure of the commissioner (requirements, functions, and responsibilities), propose candidates or help hire the service, and prepare the formal assignment. We facilitate the relationship between commissioner, board of directors, and company accounting.",
        deliverables: [
          "Model contract/assignment for the commissioner",
          "Guide to functions and obligations",
          "Appointment and registration minutes"
        ],
        requiredDocs: [
          "Proposed commissioner data",
          "Bylaws and powers",
          "Basic accounting documentation"
        ],
        icon: "fa-solid fa-user-tie",
        image: global.services + "commercial_law/5.webp",
      },
      {
        key: "books",
        title: "Management of sealed company books",
        summary:
          "We process the legalization and sealing of accounting and minute books required for operation and legal compliance.",
        details:
          "Preparation and legalization of minute books, inventories, accounting, and other required records; coordination with the Commercial Registry and notary for the corresponding sealing and registration.",
        deliverables: [
          "Books prepared for legalization",
          "Proof of sealing/registration",
          "Instructions for use and custody"
        ],
        requiredDocs: [
          "Bylaws and previous minutes",
          "Identification of administrators",
          "Powers if applicable"
        ],
        icon: "fa-solid fa-book",
        image: global.services + "commercial_law/6.webp",
      },
      {
        key: "publications",
        title: "Official publications and legal notices",
        summary:
          "Management of publications in press and gazette according to legal requirements for incorporation, amendments, and corporate acts.",
        details:
          "Drafting and coordination of mandatory insertions in newspapers or official gazettes; supervision of legal deadlines and obtaining publication certificates for incorporation into the company file.",
        deliverables: [
          "Bulletins/publications made",
          "Proof and certificate of publication",
          "Standardized texts for notices and calls"
        ],
        requiredDocs: [
          "Text approved by the company",
          "Required publication data (date, print run)",
          "Company documentation to be published"
        ],
        icon: "fa-solid fa-newspaper",
        image: global.services + "commercial_law/7.webp",
      },
      {
        key: "inventory_balance",
        title: "Inventory of assets and opening balance",
        summary:
          "Preparation of the initial inventory and opening balance required for the company's accounting start.",
        details:
          "We assemble the inventory of contributed assets and liabilities, assess initial values, and prepare the opening balance according to applicable accounting standards, including explanatory notes and supporting documentation.",
        deliverables: [
          "Detailed inventory of assets",
          "Signed opening balance ready for accounting",
          "Notes and supporting documentation"
        ],
        requiredDocs: [
          "Lists of contributions (assets, cash, securities)",
          "Invoices or property titles",
          "Valuation documentation if applicable"
        ],
        icon: "fa-solid fa-clipboard-list",
        image: global.services + "commercial_law/8.webp",
      },
      {
        key: "bank_account_opening",
        title: "Opening of corporate bank account",
        summary:
          "Assistance in managing requirements and opening corporate accounts with Venezuelan financial entities.",
        details:
          "We prepare the required banking file, accompany the presentation to the financial entity, and advise on authorized signatories, operational limits, and KYC/AML compliance requirements.",
        deliverables: [
          "Checklist of banking requirements by entity",
          "Pre-assembled file for delivery to the bank",
          "Support in appointments and validations"
        ],
        requiredDocs: [
          "Founding document and registry inscription",
          "Company RIF",
          "Signatory powers and IDs"
        ],
        icon: "fa-solid fa-university",
        image: global.services + "commercial_law/9.webp",
      },
      {
        key: "rif",
        title: "Issuance of Fiscal Information Registry (RIF)",
        summary:
          "Processing and obtaining the RIF for the company before the Venezuelan tax authority (SENIAT).",
        details:
          "We manage the entity's tax registration, submission of required documentation to the tax administration, and obtain the RIF number to start tax obligations and invoicing.",
        deliverables: [
          "Application submitted to SENIAT",
          "RIF certificate/proof",
          "Guide to initial tax obligations"
        ],
        requiredDocs: [
          "Founding document and registry inscription",
          "Representatives' IDs/RIF",
          "Fiscal address and contact details"
        ],
        icon: "fa-solid fa-id-card",
        image: global.services + "commercial_law/10.webp",
      },
      {
        key: "registrations",
        title: "Registration with INCES, IVSS, and public agencies",
        summary:
          "Management of registrations and affiliations with labor and social security entities such as INCES and IVSS.",
        details:
          "Preparation and submission of files for registration with required public agencies (INCES, IVSS, municipalities, labor registries), including guidance on periodic obligations and forms to be submitted.",
        deliverables: [
          "Files submitted and certificates",
          "Guide to compliance with periodic obligations",
          "Employer and affiliation records"
        ],
        requiredDocs: [
          "Company RIF",
          "Founding document and representatives' identification",
          "Initial labor information (estimated payroll)"
        ],
        icon: "fa-solid fa-clipboard-check",
        image: global.services + "commercial_law/11.webp",
      },
      {
        key: "contracts",
        title: "Drafting and analysis of commercial contracts",
        summary:
          "Preparation and review of commercial contracts: services, distribution, agency, supply, and other commercial agreements.",
        details:
          "We draft commercial contracts tailored to the company's activity, review liability clauses, payment terms, penalty clauses, guarantees, confidentiality, and dispute resolution; advise on negotiation and enforcement mechanisms.",
        deliverables: [
          "Draft contract and final version",
          "Analysis of contractual risks and recommendations",
          "Optional clauses and templates (NDAs, SLAs, guarantees)"
        ],
        requiredDocs: [
          "Commercial background and negotiated terms",
          "Identification of parties and tax data",
          "Relevant technical or commercial documentation"
        ],
        icon: "fa-solid fa-file-contract",
        image: global.services + "commercial_law/12.webp",
      }
    ],
  },
  ctaText: "Request commercial advice",
  ctaLink: "/contact?service=commercial-law",
};

